import { getTokens, } from "@bracket/chainography";
import { contract, multiCaller } from "@bracket/chainography/contracts";
import type { ColateralBalances,} from "@types";
import { wagmiConfig as config, } from "@wagmiconfig";


export const getTokenBalances = async (): Promise<ColateralBalances[]> => {

	try {

		const tokens = getTokens({ platform_supply: true, });

		const [ results, errors, ] = await multiCaller<Array<{ collateral: `0x${string}`; totalDeposit: bigint; whitelisted: boolean; }>>(config, tokens.map(tok => {
			return contract("BrktETH", "getCollateralInfo", tok.address);
		}));

		const balances = tokens.map((tok, idx) => {
			const { totalDeposit, } = results[idx];
			return {
				title: tok.symbol,
				value: totalDeposit,
				count: Number(totalDeposit) / 1e18,
				symbol: tok.symbol,
				label: (Number(totalDeposit) / 1e18).toFixed(2),
				completePercentage: 0,
				rate: -1,
			};
		});

		const sorted = balances.sort((tk1, tk2) => {
			if(tk1.symbol === "BRKTETH") return 1;
			if(tk1.count > tk2.count) return 1;
			return -1;
		});

		const total = sorted.reduce((acc, b) => acc + b.count, 0);

		const result = sorted.map(B => {
			B.completePercentage = (B.count / total) * 100;
			if(Number.isNaN(B.completePercentage))
				B.completePercentage = 0;
			B.label += ` (${B.completePercentage}%)`;
			return B;
		})

		return result;

	}
	catch(err) {

		console.warn("failed gaining token balances", err);
		return [];
	}
};
